import { Routes } from '@angular/router';
import { EditSituationComponent } from './edit-situation/edit-situation.component';
import { ListeSituationsComponent } from './liste-situations/liste-situations.component';

export const SITUATIONS_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const SITUATIONS_ROUTES: Routes = [
    { path: '', component: ListeSituationsComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditSituationComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditSituationComponent, data: { roles: ['ORGANISME'] } }
];
